var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ConstantValues } from '../models/bpg-constants';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
//import { BPGLoggerService } from '../../bpg-common/services/bpg-logger.service';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { environment_Local } from 'src/environments/environment.local';
import { environment_QA } from 'src/environments/environment.qa';
import { environment_PROD } from 'src/environments/environment.prod';
import 'rxjs/Rx';
import { DataService } from './data.services';
import jwt_decode from 'jwt-decode';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../environment/services/environment.configuration";
import * as i3 from "ng4-loading-spinner";
import * as i4 from "@angular/router";
import * as i5 from "./data.services";
var BpgCommonService = /** @class */ (function () {
    function BpgCommonService(http, environment1, 
    // private logger: BPGLoggerService,
    spinner, router, dataService) {
        var _this = this;
        this.http = http;
        this.environment1 = environment1;
        this.spinner = spinner;
        this.router = router;
        this.dataService = dataService;
        this.membershipUrl = ConstantValues.userManagementApiUrl.userManagementUrl;
        this.commonUrl = ConstantValues.userManagementApiUrl.userManagementUrl;
        this.financeUrl = ConstantValues.financeManagementApiUrl.financeManagementUrl;
        this.getAWSUrl = ConstantValues.userManagementApiUrl.getAWSurl;
        this.registerSiteUrl = ConstantValues.userManagementApiUrl.registerVirtualSiteUrl;
        this.codeResponse = '';
        this.tokenURL = environment.tokenUrl;
        this.isSiteOrBpgCreated = new BehaviorSubject(false);
        this.headerRefresh = new BehaviorSubject(false);
        this.loginError = new BehaviorSubject(true);
        this.setloggedInSubject$ = new BehaviorSubject(false);
        this.setloggedInObservable = function () { return _this.setloggedInSubject$.asObservable(); };
        this.isTokenReceived = new BehaviorSubject(sessionStorage.getItem('id_token') == null || sessionStorage.getItem('XAapiKey') == null ? null : true);
        this.isTokenPresent = this.isTokenReceived.asObservable();
    }
    BpgCommonService.prototype.getSessionToken = function () {
        var _this = this;
        {
            var getAWSCredURL = void 0;
            if (this.environment1.envName == 'default' || this.environment1.envName == 'local' || this.environment1.envName == 'staging') {
                getAWSCredURL = environment_Local.getAWSCredURL;
            }
            else if (this.environment1.envName == 'qa') {
                getAWSCredURL = environment_QA.getAWSCredURL;
            }
            else if (this.environment1.envName == 'prod') {
                getAWSCredURL = environment_PROD.getAWSCredURL;
            }
            var options = {
                headers: new HttpHeaders({
                    'Authorization': sessionStorage.getItem('id_token'),
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }),
            };
            var response2 = this.http.get(getAWSCredURL, options).subscribe(function (res2) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (res2 != null && res2 != undefined) {
                        sessionStorage.setItem('AccessKeyId', (res2['access-key']));
                        sessionStorage.setItem('SecretKeyId', (res2['secret-key']));
                        sessionStorage.setItem('SessionToken', (res2['session-token']));
                    }
                    return [2 /*return*/];
                });
            }); });
        }
    };
    BpgCommonService.prototype.userLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isIEOrEdge, httpOptions, redirectUri, clientId, getXApiKeyUrl, details, formBody, property, encodedKey, encodedValue, body, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.spinner.show();
                        isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
                        if (isIEOrEdge) {
                            httpOptions = {
                                headers: new HttpHeaders({
                                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                                    'Cache-Control': 'no-cache',
                                    'Pragma': 'no-cache',
                                }),
                                'responseType': 'text'
                            };
                        }
                        else {
                            httpOptions = {
                                headers: new HttpHeaders({
                                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                                })
                            };
                        }
                        this.codeResponse = sessionStorage.getItem('codeResponse');
                        if (this.environment1.envName == 'default' || this.environment1.envName == 'local' || this.environment1.envName == 'staging') {
                            redirectUri = environment_Local.redirectUri;
                            clientId = environment_Local.clientId;
                            getXApiKeyUrl = environment_Local.getXApiKeyUrl;
                        }
                        else if (this.environment1.envName == 'qa') {
                            redirectUri = environment_QA.redirectUri;
                            clientId = environment_QA.clientId;
                            getXApiKeyUrl = environment_QA.getXApiKeyUrl;
                        }
                        else if (this.environment1.envName == 'prod') {
                            redirectUri = environment_PROD.redirectUri;
                            clientId = environment_PROD.clientId;
                            getXApiKeyUrl = environment_PROD.getXApiKeyUrl;
                        }
                        details = {
                            'grant_type': 'authorization_code',
                            'client_id': clientId,
                            'code': this.codeResponse,
                            'redirect_uri': redirectUri,
                            'code_verifier': environment.codeVerifier
                        };
                        formBody = [];
                        for (property in details) {
                            encodedKey = encodeURIComponent(property);
                            encodedValue = encodeURIComponent(details[property]);
                            formBody.push(encodedKey + "=" + encodedValue);
                        }
                        body = formBody.join("&");
                        return [4 /*yield*/, this.http.post(this.tokenURL, body, httpOptions).subscribe(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                var decodedIDToken, decodedACCESSToken, BPG_IDTOKEN, BPG_ACCESSTOKEN, userEmail, userFirstName, userLastName, workdayId, options, response1;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    if (res != null) {
                                        // this.roleTypeSubject$.next(true);
                                        this.id_token = res.id_token;
                                        this.access_token = res.access_token;
                                        this.refresh_token = res.refresh_token;
                                        sessionStorage.setItem('id_token', this.id_token);
                                        sessionStorage.setItem('access_token', this.access_token);
                                        sessionStorage.setItem('refresh_token', this.refresh_token);
                                        if (this.id_token != null || this.access_token != null) {
                                            decodedIDToken = jwt_decode(this.id_token);
                                            decodedACCESSToken = jwt_decode(this.access_token);
                                            sessionStorage.setItem('BPG_IDTOKEN', JSON.stringify(decodedIDToken));
                                            sessionStorage.setItem('BPG_ACCESSTOKEN', JSON.stringify(decodedACCESSToken));
                                            BPG_IDTOKEN = sessionStorage.getItem("BPG_IDTOKEN");
                                            BPG_ACCESSTOKEN = sessionStorage.getItem("BPG_ACCESSTOKEN");
                                            userEmail = JSON.parse(BPG_ACCESSTOKEN)["upn"];
                                            userFirstName = JSON.parse(BPG_ACCESSTOKEN)["given_name"];
                                            userLastName = JSON.parse(BPG_ACCESSTOKEN)["family_name"];
                                            workdayId = JSON.parse(BPG_IDTOKEN)["WorkdayId"];
                                            sessionStorage.setItem("userEmail", userEmail);
                                            sessionStorage.setItem("userFirstName", userFirstName);
                                            sessionStorage.setItem("userLastName", userLastName);
                                            sessionStorage.setItem("workdayId", workdayId);
                                            sessionStorage.setItem('loginSuccess', 'true');
                                            sessionStorage.setItem("firstLogin", 'true');
                                            if (this.environment1.envName == 'default' || this.environment1.envName == 'local' || this.environment1.envName == 'staging') {
                                                localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl + '7000');
                                                localStorage.setItem('eventManagementUrl', this.environment1.apiBaseUrl + '7001');
                                                localStorage.setItem('financialManagementUrl', this.environment1.apiBaseUrl + '7002');
                                            }
                                            else if (this.environment1.envName == 'qa' || this.environment1.envName == 'prod') {
                                                localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl);
                                                localStorage.setItem('eventManagementUrl', this.environment1.eventapiBaseUrl);
                                                localStorage.setItem('financialManagementUrl', this.environment1.financeapiBaseUrl);
                                            }
                                            else {
                                                localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl);
                                                localStorage.setItem('eventManagementUrl', this.environment1.apiBaseUrl);
                                                localStorage.setItem('financialManagementUrl', this.environment1.apiBaseUrl);
                                            }
                                            options = {
                                                headers: new HttpHeaders({
                                                    'Authorization': sessionStorage.getItem('id_token'),
                                                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                                                }),
                                                responseType: 'text'
                                            };
                                            response1 = this.http.get(getXApiKeyUrl, options).subscribe(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                                var XAapiKey;
                                                return __generator(this, function (_a) {
                                                    XAapiKey = res;
                                                    sessionStorage.setItem('XAapiKey', XAapiKey);
                                                    this.isTokenReceived.next(true);
                                                    return [2 /*return*/];
                                                });
                                            }); });
                                        }
                                    }
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    BpgCommonService.prototype.refreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var clientId, data, refreshBody, property, encodedKey, encodedValue, body, isIEOrEdge, httpOptions, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.environment1.envName == 'default' || this.environment1.envName == 'local' || this.environment1.envName == 'staging') {
                            clientId = environment_Local.clientId;
                        }
                        else if (this.environment1.envName == 'qa') {
                            clientId = environment_QA.clientId;
                        }
                        else if (this.environment1.envName == 'prod') {
                            clientId = environment_PROD.clientId;
                        }
                        data = {
                            'grant_type': "refresh_token",
                            'client_id': clientId,
                            'refresh_token': sessionStorage.getItem('refresh_token')
                        };
                        refreshBody = [];
                        for (property in data) {
                            encodedKey = encodeURIComponent(property);
                            encodedValue = encodeURIComponent(data[property]);
                            refreshBody.push(encodedKey + "=" + encodedValue);
                        }
                        body = refreshBody.join("&");
                        isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
                        if (isIEOrEdge) {
                            httpOptions = {
                                headers: new HttpHeaders({
                                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                                    'Cache-Control': 'no-cache',
                                    'Pragma': 'no-cache',
                                })
                            };
                        }
                        else {
                            httpOptions = {
                                headers: new HttpHeaders({
                                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                                })
                            };
                        }
                        return [4 /*yield*/, this.http.post(this.tokenURL, body, httpOptions).subscribe(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (res != null) {
                                        if (res != null) {
                                            this.id_token = res.id_token;
                                            this.access_token = res.access_token;
                                            this.refresh_token = res.refresh_token;
                                            sessionStorage.setItem('id_token', this.id_token);
                                            sessionStorage.setItem('refresh_token', this.refresh_token);
                                        }
                                    }
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BpgCommonService.prototype.setloggedInHeader = function () {
        this.setloggedInSubject$.next(true);
    };
    //  async getTokens(tokenBody) {
    //   let isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    //   let tokenURL = 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/token'
    //   let httpOptions;
    //   if (isIEOrEdge) {
    //     httpOptions = {
    //       headers: new HttpHeaders({
    //         'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    //         'Cache-Control': 'no-cache',
    //         'Pragma': 'no-cache',
    //       })
    //     };
    //   } else {
    //     httpOptions = {
    //       headers: new HttpHeaders({
    //         'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    //       })
    //     };
    //   }
    //   return await this.http.post(tokenURL, tokenBody, httpOptions)
    //   .map((response: any) => response)
    //   .catch(this.handleError).toPromise();
    // }
    /** For service call to get bpg list depending on site(location)
     * @class BpgCommonService
     * @method getBPGsList
     * @param landingData
     * @returns Observable
     */
    BpgCommonService.prototype.getBPGsList = function (landingData) {
        var getBPGListUrl = this.membershipUrl + ConstantValues.membershipApiUrl.sitebpgList;
        return this.http.post(getBPGListUrl, landingData, this.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //this.logger.logException(ConstantValues.modules.bpgCommonServiceModule, '', 'Getting bpg lists details failed in bpg-site-homepage-component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get bpg list depending on userId
      * @class BpgCommonService
      * @method getMyBPGsList
      * @param myBpgsData
      * @returns Observable
      */
    BpgCommonService.prototype.getMyBPGsList = function (myBpgsData) {
        var getBPGListUrl = this.membershipUrl + ConstantValues.membershipApiUrl.bpgList;
        return this.http.post(getBPGListUrl, myBpgsData, this.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to get site list depending on userId
    * @class BpgCommonService
    * @method getSiteist
    * @param mysiteData
    * @returns Observable
    */
    BpgCommonService.prototype.getMySiteList = function (mysiteData) {
        var getSiteListUrl = this.membershipUrl + ConstantValues.membershipApiUrl.siteList;
        return this.http.post(getSiteListUrl, mysiteData, this.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to get site list of the user
     * @class BpgCommonService
     * @method getSiteList
     * @param myBpgsData
     * @returns Observable
     */
    BpgCommonService.prototype.getSiteList = function (siteData) {
        var getBPGListUrl = this.membershipUrl + ConstantValues.userManagementApiUrl.siteList;
        return this.http.post(getBPGListUrl, siteData, this.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to get site list of the user
     * @class BpgCommonService
     * @method getRegisteredSiteList
     * @param myBpgsData
     * @returns Observable
     */
    BpgCommonService.prototype.getRegisteredSiteList = function (userId) {
        var getBPGListUrl = this.membershipUrl + this.registerSiteUrl;
        return this.http.get(getBPGListUrl + userId, this.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to get chapter members details depending on siteIds and bpgId
   * @class BpgCommonService
   * @method getChapterEmailList
    * @param myData
   * @returns Observable
   */
    BpgCommonService.prototype.getChapterEmailList = function (myData) {
        var getChapterEmailUrl = this.membershipUrl + ConstantValues.membershipApiUrl.chapterEmailList;
        return this.http.post(getChapterEmailUrl, myData, this.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to login to bpg application locally
       * @class BpgCommonService
       * @method login
       * @param loginData
       * @returns Observable
       */
    BpgCommonService.prototype.login = function (loginData) {
        var loginUrl = this.commonUrl + ConstantValues.commonApiUrl.login;
        return this.http.post(loginUrl, loginData)
            .pipe(map(function (data) {
            return data;
        }));
    };
    BpgCommonService.prototype.loginMonitor = function (loginData) {
        var loginUrl = this.commonUrl + ConstantValues.commonApiUrl.loginMonitor;
        return this.http.post(loginUrl, loginData, this.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        }));
    };
    BpgCommonService.prototype.checkSiteAffected = function (value) {
        var checkSiteAffectedUrl = this.commonUrl + ConstantValues.commonApiUrl.checkSiteAffected + value;
        return this.http.get(checkSiteAffectedUrl, this.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        }));
    };
    BpgCommonService.prototype.numberOnly = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    };
    /** For service call to get bpg list
       * @class BpgCommonService
       * @method getUserRoleDetails
       * @param userData
       * @returns Observable
       */
    BpgCommonService.prototype.getUserRoleDetails = function (userData) {
        var userRoleDetailsUrl = this.commonUrl + ConstantValues.commonApiUrl.userRole;
        return this.http.post(userRoleDetailsUrl, userData, this.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to get bpg list
       * @class BpgCommonService
       * @method getChapterDetails
       * @param chapterDetailsData
       * @returns Observable
       */
    BpgCommonService.prototype.getChapterDetails = function (chapterDetailsData) {
        // console.log("hhhh=="+chapterDetailsData);
        var chapterDetailsUrl = this.commonUrl + ConstantValues.userManagementApiUrl.chapterDetails;
        return this.http.post(chapterDetailsUrl, chapterDetailsData, this.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to get chapter folder list
     * @class BpgCommonService
     * @method getChapterFolderDetails
     * @param getChapterFolderDetails
     * @returns Observable
     */
    BpgCommonService.prototype.getChapterFolderDetails = function (getChapterFolderDetails) {
        // console.log("hhhh=="+chapterDetailsData);
        var chapterDetailsUrl = this.commonUrl + ConstantValues.userManagementApiUrl.chapterFolderDetails;
        console.log(chapterDetailsUrl);
        return this.http.post(chapterDetailsUrl, getChapterFolderDetails, this.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to get bpg list
       * @class BpgCommonService
       * @method withdrawMemberShip
       * @param userId
       * @returns Observable
       */
    BpgCommonService.prototype.withdrawMemberShip = function (userId) {
        //console.log("id===-====-=0-0=="+userId);
        var withdrawMembershipUrl = this.commonUrl + ConstantValues.userManagementApiUrl.withdrawMembership;
        return this.http.delete(withdrawMembershipUrl + userId, this.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to get bpg list
       * @class BpgCommonService
       * @method getChapterLeadershipDetails
       * @param chapterId
       * @returns Observable
       */
    BpgCommonService.prototype.getChapterLeadershipDetails = function (chapterId) {
        var chapterLeadershipDetailsUrl = this.commonUrl + ConstantValues.userManagementApiUrl.chapterLeadershipDetails;
        return this.http.post(chapterLeadershipDetailsUrl, chapterId, this.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to get bpg list
       * @class BpgCommonService
       * @method getUserSiteDeatils
       * @param siteId
       * @returns Observable
       */
    BpgCommonService.prototype.getUserSiteDeatils = function (siteId) {
        //console.log("site bnsdjhshjhafgjghs"+siteId);
        var userSiteDetailsUrl = this.commonUrl + ConstantValues.userManagementApiUrl.userSiteDetails;
        return this.http.post(userSiteDetailsUrl, { "siteId": siteId }, this.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            // this.logger.logException(ConstantValues.modules.bpgCommonServiceModule, '', 'Getting user site details failed in bpg-site-homepage-component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get bpg list
       * @class BpgCommonService
       * @method getUserDetails
       * @param userId
       * @returns Observable
       */
    BpgCommonService.prototype.getUserDetails = function (userId) {
        var userDetailUrl = this.commonUrl + ConstantValues.commonApiUrl.userDetails;
        return this.http.post(userDetailUrl, { "userId": userId }, this.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to check for ADAL login
       * @class BpgCommonService
       * @method tokenizedHeader
       * @returns header options
       */
    BpgCommonService.prototype.tokenizedHeader = function () {
        //console.log("Header Authorized : " + this.adalService.userInfo.token);
        //if(ConstantValues.env.loginADAL == true) {
        if (localStorage.getItem('logOutFlag') == "true") {
            localStorage.clear();
            sessionStorage.clear();
            //this.router.navigate['/log-out'];
            localStorage.setItem("logOutFlag", "true");
        }
        else {
            if (sessionStorage.getItem('id_token') == null) {
                this.userLogin();
            }
            if (sessionStorage.getItem('id_token') != null) {
                if (sessionStorage.getItem("XAapiKey") != null && sessionStorage.getItem("XAapiKey") != undefined) {
                    var headers = new HttpHeaders({
                        Authorization: sessionStorage.getItem("id_token"),
                        "X-Api-Key": sessionStorage.getItem("XAapiKey"),
                    });
                }
                else {
                    var headers = new HttpHeaders({
                        Authorization: sessionStorage.getItem("id_token"),
                    });
                }
                //}
                var options = { headers: headers };
                //console.log("Header Authorized option : " + this.adalService.userInfo.token);
                return options;
            }
        }
    };
    /** For service call to get user data by email id
     * @class BpgCommonService
     * @method userDetailsByEmailId
     * @param emailData
     * @returns Observable
     */
    BpgCommonService.prototype.userDetailsByEmailId = function (emailData) {
        if (this.commonUrl == null) {
            this.commonUrl = localStorage.getItem('userManagementUrl');
        }
        var loginUrl = this.commonUrl + ConstantValues.commonApiUrl.userDetailsByEmailId;
        return this.http.post(loginUrl, emailData, this.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to get AWS Base URL
    * @class BpgCommonService
    * @method getAwsUrl
    * @param awsData
    * @returns Observable
    */
    BpgCommonService.prototype.getAwsUrl = function (awsData) {
        var awsUrl = this.commonUrl + this.getAWSUrl;
        return this.http.post(awsUrl, awsData, this.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        }));
    };
    BpgCommonService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BpgCommonService_Factory() { return new BpgCommonService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.EnvironmentConfiguration), i0.ɵɵinject(i3.Ng4LoadingSpinnerService), i0.ɵɵinject(i4.Router), i0.ɵɵinject(i5.DataService)); }, token: BpgCommonService, providedIn: "root" });
    return BpgCommonService;
}());
export { BpgCommonService };
